<template>
  <el-form ref="form" :model="form" :rules="rules" size="mini">
    <p class="text-sm pb-2">
      企业使用本地或云化部署的信息化服务，实现以下哪些业务环节的数字化管理。
      <span class="text-xs text-red-400"> (上传文件最大限制10MB) </span>
    </p>
    <el-row
      class="border-collapse border border-gray-600 border-solid border-spacing-2"
      v-for="(item, index) in list"
      :key="index"
    >
      <el-col class="pl-5" :span="8">
        <el-checkbox
          :value="!!form[index]"
          @change="(val) => handleChange(val, index)"
          >{{ item }}</el-checkbox
        >
      </el-col>
      <el-col :span="16" v-if="form[index]" :key="index">
        <div
          v-for="(file, i) in form[index].fileIds"
          :key="i"
          class="flex space-x-2"
        >
          <el-button type="text" plain @click="down(file)" title="点击下载">{{
            `${i + 1}:${file.name}`
          }}</el-button>
          <el-button type="text" plain @click="form[index].fileIds.splice(i, 1)"
            >移除</el-button
          >
        </div>
        <el-form-item
          prop="fileIds"
          :rules="{
            validator: (rule, value, cb) => {
              form[index].fileIds.length > 0
                ? cb()
                : cb(makeError('佐证材料不能为空'));
            },
          }"
        >
          <el-upload
            :headers="headers"
            class="uploader"
            action="/dev/minio"
            :before-upload="beforeUpload"
            :on-success="
              (res, file, fileList) => handleSuccess(res, file, fileList, index)
            "
            :on-error="handleError"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button v-if="!isView" @click="handleSave" type="primary"
        >确认</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import store from "../../../store";
export default {
  props: ["ans", "isView", "cb", "down", "upload"],
  data() {
    return {
      form: {},
      rules: {
        fileIds: {
          validator: (rule, value, cb) => {},
        },
      },
      list: [
        "产品设计",
        "工艺设计",
        "营销管理",
        "售后服务",
        "计划排程",
        "生产管控",
        "质量管理",
        "设备管理",
        "安全生产",
        "能耗管理",
        "采购管理",
        "仓储物流",
        "财务管理",
        "人力资源",
      ],
      headers: { Authorization: "Bearer " + store.getters.token },
    };
  },
  mounted() {
    this.form = { ...this.ans };
  },
  methods: {
    makeError(msg) {
      return new Error(msg);
    },
    handleUpload(fn, index) {
      fn().then((data) => {
        this.form[index].fileIds.push(data);
      });
    },
    //上传前校验
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }
      return true;
    },
    handleSuccess(response, file, fileList, index) {
      this.form[index].fileIds.push(response.data);
    },
    handleError(err, file) {
      this.$message.error(err);
    },
    handleChange(val, index) {
      if (val) {
        this.$set(this.form, index, { fileIds: [] });
      } else {
        this.$delete(this.form, index);
      }
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.cb(this.form);
        }
      });
    },
  },
};
</script>
